import { CompletedCycles } from '../../CompletedCycles/CompletedCycles';

export const Completed = () => {
  return (
    <div className="c-cycles-by-status flex flex-auto flex-col gap-y-2">
      <CompletedCycles />
    </div>
  );
};
